import { useState, useCallback } from "react";

export function useMom() {
  const [mom, setMom] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateMom = useCallback(async (transcript) => {
    if (!transcript || transcript.trim().length < 20) {
      setError("Need more transcript text to generate MoM.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch("https://turn.pristine.farm/api/mom", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ transcript }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || "MoM API error");
      }

      setMom(data.mom || "");
    } catch (e) {
      console.error("MoM generation failed:", e);
      setError(e.message || "Failed to generate MoM.");
    } finally {
      setLoading(false);
    }
  }, []);

  return { mom, loading, error, generateMom };
}
